import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation} from "@angular/core";
import {Modal} from "../../../../../services/modal.service";
import {Table} from "../../../../../../common/interfaces/table.interface";
import {AppStateService} from "../../../../../../common/services/app-state.service";


@Component({
    selector: "section-order-track-content",
    template: `
        <h1 class="container-heading">Shipment content</h1>
        <mat-card>
            <mat-card-content>
                <common-table2 *ngIf="listTable" [settings]="listTable"></common-table2>
            </mat-card-content>
        </mat-card>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})

export class OrderTrackContentComponent implements OnInit {

    public listTable: Table.ISettings;

    public modal: Modal.IModal;

    public constructor(private changeDetectorRef: ChangeDetectorRef) {
    }

    /**
     * Prepare list/table
     * @returns {void}
     */
    private prepareList(): void {

        this.listTable = {
            actions: [],
            columns: [
                {
                    data: "item",
                    title: "Item"
                },
                {
                    data: "serial",
                    title: "Serial"
                },
                {
                    data: "configurations",
                    title: "Configurations"
                },
                {
                    data: "batch",
                    title: "Batch"
                },
                {
                    data: "quantity",
                    title: "Quantity"
                },
                {
                    data: "inventory_conversion.customers_inventory_name",
                    title: "Customers inventory name"
                }, {
                    data: "inventory_conversion.customers_sub_inventory",
                    title: "Customers sub inventory"
                },
                {
                    data: "inventory_conversion.gb",
                    title: "Gb"
                },
                {
                    data: "ref",
                    title: "Ref"
                },
                {
                    data: "ref2",
                    title: "Ref2"
                },
            ],
            api: {
                url: [
                    AppStateService.getState().section,
                    "warehouse-transactions"
                ],
                query: {
                    "courier_transaction_id": this.modal.params.data.id,
                    relations:[
                        "InventoryConversion:id,customers_inventory_name,customers_sub_inventory,gb"
                    ]
                },
                version: 3
            }
        };
        this.changeDetectorRef.markForCheck();
    }

    public ngOnInit(): void {
        this.prepareList();
    }
}
